import React from 'react';
import { NavigateFunction } from 'react-router';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import { TDashboardAssetSummaryPerOrganization } from '@interfaces/platform/platformDashboard';

import { routes } from '@constants/routes';
import { columnSizes } from '@constants/table';

import ViewOrganizationTableCell from '../ViewOrganizationTableCell';

const { adminPanel: { index, organisations } } = routes;

export const getColumns = ({ navigate }: { navigate: NavigateFunction }) => ([
	{
		header: 'Organisation',
		accessorKey: 'organizationName',
		size: columnSizes.size300,
		cell: ({ row }: CellContext<TDashboardAssetSummaryPerOrganization, any>) => {
			const { organizationName, organizationId, logo } = row.original || {};

			const openOrganizationProfile = () => {
				if (!organizationId) return;

				navigate(`${index}${organisations}/organisation-profile/${organizationId}`);
			};

			return (
				<ViewOrganizationTableCell
					avatarId={logo?.id}
					onClick={openOrganizationProfile}
					text={organizationName}
					tooltipLabel='Company profile'
				/>
			);
		},
	},
	{
		header: 'Assets',
		accessorKey: 'allAssets',
		cell: ({ getValue }: CellContext<TDashboardAssetSummaryPerOrganization, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value} />;
		},
	},
	{
		header: 'Hidden',
		accessorKey: 'hiddenAssets',
		cell: ({ getValue }: CellContext<TDashboardAssetSummaryPerOrganization, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value} />;
		},
	},
	{
		header: 'On the map',
		accessorKey: 'showedAssets',
		cell: ({ getValue }: CellContext<TDashboardAssetSummaryPerOrganization, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value} />;
		},
	},
]);
